import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const ExportButton = forwardRef(({ title = 'Export', ...props }, ref) => (
  <BaseButton
    ref={ref}
    id='export-button'
    icon='export'
    tooltip={title}
    themeColor='light'
    {...props}
  />
));

export default ExportButton;
